<div class="apiz-p-grid">
  <ng-template iuDynamicContainer />
</div>
